import {
    arePinnedBooksLoading,
    ensurePinnedBooksLoaded,
    getPinnedBookIdsSnapshot,
    getPinnedBooksLoadingServerSnapshot,
    getPinnedBooksServerSnapshot,
    hydratePinnedBooks,
    isBookPinned,
    subscribePinnedBooks,
    togglePinnedBook,
} from '@/lib/pinned-books-store';
import { useEffect, useSyncExternalStore } from 'react';

export { hydratePinnedBooks };

export function usePinnedBookIds(): string[] {
    useEffect(() => {
        void ensurePinnedBooksLoaded();
    }, []);

    return useSyncExternalStore(subscribePinnedBooks, getPinnedBookIdsSnapshot, getPinnedBooksServerSnapshot);
}

export function usePinnedBooksLoading(): boolean {
    useEffect(() => {
        void ensurePinnedBooksLoaded();
    }, []);

    return useSyncExternalStore(subscribePinnedBooks, arePinnedBooksLoading, getPinnedBooksLoadingServerSnapshot);
}

export function useIsBookPinned(bookId: string): boolean {
    useEffect(() => {
        void ensurePinnedBooksLoaded();
    }, []);

    return useSyncExternalStore(
        subscribePinnedBooks,
        () => isBookPinned(bookId),
        () => false,
    );
}

export function useTogglePinnedBook(): (bookId: string) => void {
    return togglePinnedBook;
}

/** Convenience for list pages that need the full id list plus helpers. */
export function usePinnedBooks(initialPinnedIds?: string[]) {
    if (initialPinnedIds) {
        hydratePinnedBooks(initialPinnedIds);
    }

    const pinnedIds = usePinnedBookIds();
    const togglePin = useTogglePinnedBook();

    return {
        pinnedIds,
        togglePin,
        isPinned: (bookId: string) => pinnedIds.includes(bookId),
    };
}
